import { useParams } from 'react-router'
import PractitionerPayoutReceipts from 'src/supportPortal/components/common/mentor/payoutInvoice/PractitionerPayoutReceipts'

export default function DoctorsPayoutReceipts() {
  const { mentorSlug } = useParams()
  return (
    <PractitionerPayoutReceipts
      fetchSingleMentorSignature={`/api/secure/cc/support/doctor/by-slug`}
      mentorSlug={mentorSlug}
    />
  )
}
